import { render, staticRenderFns } from "./ScreenSaver.vue?vue&type=template&id=7ceb1e27&scoped=true&"
import script from "./ScreenSaver.vue?vue&type=script&lang=ts&"
export * from "./ScreenSaver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceb1e27",
  null
  
)

export default component.exports